module.exports = __webpack_public_path__ + "img/building-inner.510d925.png";